import React from "react";

/**
 * ReportHeader — Reusable Header & Filter Bar for Reports
 * 
 * Purpose:
 * Renders a compact filter and action bar without large, redundant
 * page titles and subtitles (which are already displayed in the top navbar breadcrumbs).
 * 
 * Props:
 * - filters / filterSlot / children: Filter inputs (DatePickers, Selects, Toggles, etc.)
 * - actions / actionsSlot: Action buttons on the right (Export to Excel, etc.)
 * - className: Optional class overrides
 */
const ReportHeader = ({
  filters,
  filterSlot,
  actions,
  actionsSlot,
  children,
  className = "",
  noWrap = false,
}) => {
  const filterContent = filters || filterSlot || children;
  const actionContent = actions || actionsSlot;

  return (
    <div
      className={[
        noWrap
          ? "flex flex-row flex-nowrap items-center justify-between gap-3 mb-3 py-1 w-full"
          : "flex flex-row flex-wrap items-end justify-between gap-4 mb-3 py-1 w-full",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {/* Left / Center: Filter Inputs */}
      {filterContent && (
        <div className={noWrap ? "flex flex-row flex-nowrap items-center gap-2.5 shrink-0" : "flex flex-row flex-wrap items-center gap-3 flex-grow"}>
          {filterContent}
        </div>
      )}

      {/* Right: Actions (e.g. Export to Excel) */}
      {actionContent && (
        <div className={noWrap ? "flex items-center gap-2 shrink-0 flex-nowrap" : "flex items-center gap-2 ml-auto self-end"}>
          {actionContent}
        </div>
      )}
    </div>
  );
};

export default ReportHeader;
